<template>

<div class="TDsByYear-wrapper">
  <div v-for="(game,index) in tds" class="game-wrapper">
    <div class="game-header">
    
      <div class="game-number"><span>{{index}}</span></div>
      <div class="game-date"><span>{{game[0].Date}}</span></div>
      <div class="game-info" v-bind:style="{ backgroundImage: 'url(' + game[0].OppImg + ')'}">


      <!--<div class="game-info--logo" v-bind:style="{ backgroundImage: 'url(' + game[0].OppImg + ')'}"></div>-->
        <div class="game-opp-wrap">
        <div class="homeaway" v-if="Object.keys(game[0].FIELD6).length === 0">VS</div>
        <div class="homeaway" v-else>@</div>
        {{game[0].Opp}}
         </div>
       </div>
    </div>
   <div class="all-tds-wrapper" v-if="game[0].ScorerFname!=''">
      <div v-for="(index) in game" class="touchd-wrapper" >
        <div class="touchd-left">
        <img class="img-headshot" :src="index.ScorerImg" :alt="index.ScorerFname + ' ' + index.ScorerLname + ' Headshot'">

        <!--COOL CODE
      v-bind:style="{ backgroundImage: 'url(' + index.ScorerImg + ')'}" -->


        <!--<div class="receiver-headshot"><img src="https://www.thesportsbank.net/core/wp-content/uploads/2015/05/Curtis-Conway-headshot.jpg"></div>
          <span class="touchd-tdnumber">TD #{{index.Touchdown}}</span>
          <span class="touchd-gamesituation">{{index.ScoreBefore}}</span>
          <span class="touchd-right-scenario">{{index.Quarter}} QTR</span>-->
        </div>
        <div class="touchd-center" >
          <div class="touchd-center-top">{{index.Yards}}</div>
          <div class="touchd-center-middle" v-bind:style="{ height: index.Yards + 'px',  }"></div>
          <div class="touchd-center-bottom">YDS</div>
        </div>
        <div class="touchd-right">
          <!--<div class="touchd-right--yards">
            <span class="touchd-yards">{{index.Yards}} Yards</span> to
          </div>-->
          <div class="touchd-right--receiver">
          <span class="touchd-tdnumber">TD #{{index.Touchdown}}</span>
            <span class="scorer-fname">{{index.ScorerFname}}</span>
            <span class="scorer-lname">{{index.ScorerLname}}</span>
          </div>
        </div> 
      </div>
    </div>
  </div>
</div>

</template>

<script>

import axios from 'axios';

export default {
  name: 'TDsByYear',
  props: ["tds"],
  data: function () {
    return {
      games: [],
      year: {}
  }
  },
  methods: {

  },
  mounted(){
     console.log(this.tds, "Mounted returns the TDs");
  }
}

</script>

<style>
.receiver-headshot {
  position:absolute;
}

.homeaway {
    margin-right: 5px;
    font-size: 35px;
}

.game-info--logo {
    width: 100px;
    height: 100px;
    background-size: cover;
    margin-right: 20px;
}

.game-header-spacer {
    width: 4px;
    height: 100%;
    min-height: 72px;
    background: #d9c08e;
    transform: skewX(-12deg);
    box-shadow: 2px 0px 2px -1px #b1aa8a;
}


.TDsByYear-wrapper{}
.game-wrapper {
  display:flex;
  flex-direction:column;
}
.game-wrapper:nth-of-type(even) {
  background-color:#fcfcfc;
}
.game-wrapper:nth-of-type(odd) {
    background-color: #fff;
}
.game-header {
  display:flex;
  justify-content:space-around;
  font-family: 'Teko', sans-serif;
    font-size: 50px;
    text-transform: uppercase;
    background-color: #D3BC8D;
    box-shadow: 4px 9px 10px -10px #514d3a;
    color: black;
    background-size: 10%;
    background-position: 65% 50%;
    background-repeat: no-repeat;
    height: 70px;
    background: linear-gradient(180deg,#dbcf9b 0,#d3bc8d 50%,#bfa980 51%,#d3bc8d);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#dbcf9b",endColorstr="#d3bc8d",GradientType=0);
    /* color: #fff; */
}

/*
.game-wrapper:nth-of-type(even) .game-header {
    background: linear-gradient(180deg,#ffffff 0,#dcdcdc 50%,#cecece 51%,#d0d0d0);
}
*/

.game-header > div {

    display:flex;
    justify-content:flex-start;
    align-items:center;
    padding-left:30px;
}

.game-header .game-number {
  width:25%;
}
.game-header .game-date {
  width:25%;
}



.game-number > span, .game-date > span {
    box-shadow: 0px 0px 16px -5px #5b5b5bd4;
    height: 50px;
    line-height: 58px;
    padding: 0px 12px;
}

.game-header .game-info {
    width: 50%;
    background-image: url(https://static.nfl.com/static/content/public/static/wildcat/assets/img/logos/teams/NE.svg);
    background-size: 40%;
    background-repeat: no-repeat;
    background-position: 75%;
}

.game-header > .game-header-spacer {
    position: relative;
    top: 0px;
}

.all-tds-wrapper {
    display:flex;
    flex-wrap:wrap;

}
.td-wrapper{
  width:33%;
}






.touchd-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 150px;
    width: 33%;
    font-family: 'Teko', sans-serif;
    font-size: 24px;
   transition-duration:300ms;
   color:#000;
   box-shadow: 12px 0px 30px -20px #000000e0;
       background-repeat: no-repeat;
    background-size: 106px;
}



.touchd-left {
    flex: 2;
    display: flex;
    flex-direction: column;
    min-height: 90px;
        height: 100%;
    justify-content: center;
        align-items: center;
}

img.img-headshot {
    height: 79%;
    display: block;
    box-shadow: 0px 0px 75px -23px black;
    border: 7px solid #fcfcfc;
}


.touchd-right {
    flex: 3;
    overflow: hidden;
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    text-align: left;
}

.touchd-center {
display:flex;
flex-direction:row;
  align-items:center;
  justify-content:center;
    font-size: 22px;
    margin: 20px;
}

.touchd-center-middle {
    background-color: #D3BC8D;
    min-width: 11px;
    height: 75%;
    margin: 2px 10px;
    position: relative;
    border-right: 2px solid #baa479;
    border-left: 2px solid #f6daa2;
    border-top: 2px solid #cab385;
    -webkit-box-shadow: 0.5px 3px 6px -2px #00000061;
    box-shadow: 0.5px 3px 6px -2px #00000061;
}





.game-opp-wrap {
    display: flex;
    height: 50px;
    line-height: 58px;
    padding: 0px 12px;
        box-shadow: 0px 0px 16px -5px #5b5b5bd4;
}


.touchd-wrapper > div:last-of-type {
    margin-right: 0px;
}

.touchd-right--yards {
    position: relative;
    top: 3px;
    position: relative;
    z-index: 2;
}



.touchd-right--receiver {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    top: 7px;
}




.touchd-right--receiver span {
    display: block;
    line-height: 24px;
    position: relative;
    text-transform: uppercase;
}



.touchd-left > span {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.touchd-tdnumber {
    font-size: 37px;
    line-height: 37px;
    display: block;
    color: #000000;
}


span.touchd-gamesituation {
    font-size: 14px;
    font-weight: 500;
    background-color: #e8e8e8;
    line-height: 20px;
    padding-right: 4px;
  margin-top: 3px;
    background: -moz-linear-gradient(left, rgba(232,232,232,0) 24%, rgba(232,232,232,1) 100%);
    background: -webkit-linear-gradient(left, rgba(232,232,232,0) 24%,rgba(232,232,232,1) 100%);
    background: linear-gradient(to right, rgba(232,232,232,0) 24%,rgba(232,232,232,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00e8e8e8', endColorstr='#e8e8e8',GradientType=1 );
}




.touchd-yards {
    font-weight: 300;
    font-size: 30px;
    line-height: 30px;
}

span.scorer-fname {
    font-size: 34px;
    line-height: 34px;
}

span.scorer-fname:after {
    content: '';
    width: 88%;
    background: #e8e8e8;
    height: 6px;
    position: absolute;
    top: 8px;
    margin-left: 10px;
    /* border-bottom: 1px solid #000000; */
    /* border-left: 1px solid #313131; */
    /* border-top: 1px solid #5a5a5a; */
}



span.scorer-lname {
    display: block;
    line-height: 35px;
    font-size: 35px;
    position: relative;
    top: -2px;
    font-weight: 800;
}

span.scorer-lname:after {
    content: '';
    width: 88%;
    background: #e8e8e8;
    height: 6px;
    position: absolute;
    top: 10px;
    margin-left: 10px;
}


.touchd-right-scenario {
    font-size: 14px;
}




@media (max-width:1366px)  {

  .touchd-tdnumber {
    font-size: 30px;
    line-height: 30px;
}
span.scorer-lname {
    line-height: 23px;
    font-size: 23px;
}
span.scorer-lname:after {
    top: 7px;
}
.game-header {

    font-size: 30px;

}

.game-info--logo {
    width: 60px;
    height: 60px;
}

.game-header .game-info {
    background-size: 60%;
    background-position: 109%;
}

}

@media (max-width:1023px)  {

.game-header .game-number {
  width:23%;
}
.game-header .game-date {
  width:27%;
}
.game-header .game-info {
  width:50%;
}


}


@media (max-width:975px)  {
 .touchd-wrapper {
   width:50%; 
  }

}

@media (max-width:700px)  {


.game-number > span, .game-date > span {
    height: initial;
    line-height: initial;
}




  .homeaway {
    margin-right: 5px;
    font-size: 16px;
}

.touchd-wrapper {
    width: 100%;
    min-height:90px;
    height: 120px;
    box-shadow: 0px 5px 9px -4px #00000042;
}

    .touchd-tdnumber {
    font-size: 24px;
    line-height: 24px;
}
  .touchd-gamedate {
    font-size: 14px;
    line-height: 18px;
}
  .touchd-gamenumber {
    font-size: 18px;
    line-height: 18px;
}
.touchd-yards {
    font-weight: 300;
    font-size: 20px;
    line-height: 20px;
}
span.scorer-fname {
    line-height: 19px;
    font-size: 26px;
}

.game-opp-wrap {
    height: 23px;
    line-height: 26px;
}

span.scorer-lname {
    line-height: 32px;
    font-size: 26px;
}
span.scorer-fname:after {
    top: 4px;
}


.game-header-spacer {
    min-height: 35px;

}

.game-info--logo {
    width: 40px;
    height: 40px;
    margin-right: 10px;
}

.game-header {
    font-size: 16px;
    height: 43px;
}



}

@media (max-width:420px)  {

.game-header > div {
    padding-left: 7px;
}


}




:root {
  --progress-bar-height: 4px;
  --progress-bar-color: gainsboro;
  --progress-bar-value-color: dodgerblue;
  --progress-bar-value: 20%;
}

.article-title {
    position: fixed;
    width: 70px;
    background: #e6dcac;
    height: 37px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Exo 2', sans-serif;
    font-weight: 800;
}

.progress-wrapper {
  position: relative;
}

.progress-label {
    position: ;
    right: 0;
    bottom: 0;
    font-size: 30px;
}

progress {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  position: absolute;
  width: 100%;
  height: var(--progress-bar-height);
  background-color: var(--progress-bar-color);
  border: none;
}
progress::-moz-progress-bar {
  background-color: var(--progress-bar-value-color);
}
progress::-webkit-progress-bar {
  background-color: var(--progress-bar-color);
}
progress::-webkit-progress-value {
  background-color: var(--progress-bar-value-color);
}
progress::-ms-fill {
  background-color: var(--progress-bar-value-color);
}


</style>


// WEBPACK FOOTER //
// src/components/TDsByYear.vue